import { configureStore } from "@reduxjs/toolkit";
import collectionBarReducer from "./ducks/collection-bar";
import customerCaptureOverlayReducer from "./ducks/customer-capture-overlay";
import feedSwitchTabOverlayReducer from "./ducks/feed-switch-tab-overlay";
import feedFiltersReducer from "./ducks/feed-filters";
import feedSidebarReducer from "./ducks/feed-sidebar";
import signupOverlayReducer from "./ducks/signup-overlay";
import appHeaderSearchReducer from "./ducks/app-header-search";
import appHeaderCartReducer from "./ducks/app-header-cart";
import shippingAndReturnsOverlayReducer from "./ducks/shipping-and-returns-overlay";
import feedShowMoreReducer from "./ducks/feed-show-more";
import feedSeoContentReducer from "./ducks/feed-seo-content";
import mainNavigationReducer from "./ducks/main-navigation";

const store = configureStore({
    reducer: {
        collectionBarReducer,
        customerCaptureOverlayReducer,
        feedSwitchTabOverlayReducer,
        feedFiltersReducer,
        feedSidebarReducer,
        signupOverlayReducer,
        appHeaderSearchReducer,
        appHeaderCartReducer,
        shippingAndReturnsOverlayReducer,
        feedShowMoreReducer,
        feedSeoContentReducer,
        mainNavigationReducer,
    },
});

export type ReduxStoreState = ReturnType<typeof store["getState"]>;

export default store;
